export enum IntegrationProviderSlug {
  Slack = 'slack',
}
